export default {
  titulo: "Satisfaction Surveys",
  columnaTitulo: "Title",
  nueva: "New Survey",
  eliminar: "Delete Survey",
  pregEliminar: "Are you sure you want to delete the survey?",
  verPreguntas: "View Questions",
  aplicada: "Applied to",
  opcionRep: "Repair Orders",
  opcionServ: "Service Orders",
  repYserv: "Repair and Service Orders",
  aplicable: "The survey applies to:",
  logo: "Logo",
  izquierda: "Left",
  derecha: "Right",
  nuevaPregunta: "New Question",
  preguntas: "Questions",
  preguntaNro: "Question #",
  msgIngresarPreg: "Enter at least one question to continue",
  textoAyuda: "Help Text",
  tipo: "Question Type",
  cuadroTexto: "Text box for customer response",
  opcion: "Option",
  opciones: "Options",
  tipos: {
    texto: "Text",
    radio: "Radio",
    check: "Check",
    lista: "List",
    escala: "Scale"
  },
  sub: "Subtitle",
  eliminarPreg: "Delete Question",
  pregEliminarPreg: "Are you sure you want to delete the question?",
  EliminarOpcion: "Delete Option",
  pregEliminarOpcion: "Are you sure you want to delete the option?"
}
